import { render, staticRenderFns } from "./admin-dialog.vue?vue&type=template&id=82c5059e&"
import script from "./admin-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports